export class Activity {
    public activityType: string;
    public editMode: boolean;
    public activityID: string;
    public activityDescription: string;
    constructor(data: any = {}) {
        this.activityID = data.activityID || '';
        this.activityType = data.activityType || '';
        this.activityDescription = data.description || '';
        this.editMode = false;
    }
}

export class EditActivity {
    public activityType: string;
    public activityDescription: string;
    public activityID: string;
    public updateItems: UpdatedItem;
    public userObj: any;
    constructor(newData, oldData, userObj) {
        oldData.forEach(value => {
            if (newData.activityID === value.activityID) {
                this.activityType = value.activityType || '';
                this.activityID = value.activityID || '';
            }
        });
        this.activityDescription = oldData.activityDescription || '';
        this.userObj = userObj || '';
        this.updateItems = new UpdatedItem(newData) || new UpdatedItem({});
    }
}

export class UpdatedItem {
    public activityType: string;
    public description: string;
    constructor(newData: any = {}) {
        this.activityType = newData.activityType;
        this.description = newData.activityDescription;
    }
}


// WEBPACK FOOTER //
// ./src/app/admin/tasks/task.ts